const subscriptionPlanOrder = {
  main: [
    { name: 'xs_2021_09', key: 'main_xs' },
    { name: 'xs_2026', key: 'main_xs' },
    { name: 's_2021_09', key: 'main_s' },
    { name: 's_2021', key: 'main_s' },
    { name: 's_2026', key: 'main_s' },
    { name: 'm_2021_09', key: 'main_m' },
    { name: 'm_2021', key: 'main_m' },
    { name: 'm_2026', key: 'main_m' },
    { name: 'l_2021_09', key: 'main_l' },
    { name: 'l_2021', key: 'main_l' },
    { name: 'l_2026', key: 'main_l' },
  ],
  document: [
    { name: 'document_s', key: 'document_xs' },
    { name: 'document_m', key: 'document_s' },
    { name: 'document_l', key: 'document_m' },
    { name: 'document_xl', key: 'document_l' },
  ],
  staff: [
    { name: 'staff', key: 'staff' },
  ],
}

export default subscriptionPlanOrder
